import axios from 'axios';
import { useContext } from 'react';
import { ApiContext } from '~/services/store/api';

export const isAxiosError = axios.isAxiosError;

/**
 * Hook que retorna a instância de API conforme o fluxo ativo.
 * Consome do ApiContext (ApiProvider no fluxo Keycloak, BeApiProvider no fluxo Becompliance).
 */
export const useApi = () => {
  const context = useContext(ApiContext);

  if (!context?.getApi) {
    throw new Error(
      'useApi deve ser usado dentro de ApiProvider (Keycloak) ou BeApiProvider (Becompliance)'
    );
  }

  return context.getApi;
};
